import { NotificationDetailPage } from "@/pages/notification-detail";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/notifications/$id/")({
  component: () => {
    const { id: strId } = useParams({ strict: false });
    const id = Number(strId);
    return <NotificationDetailPage id={id} />;
  },
});
